import styled from 'styled-components'
import { themeColor } from '@elparking/components'

const LoaderBar = styled.div`
    width: 100%;
    height: 3px;
    animation: head-loaderBar-keyframes 4s infinite;

    @keyframes head-loaderBar-keyframes {
        from {
            background: ${themeColor('accent70')};
            width: 0%;
        }
        to {
            background: ${themeColor('accent70')};
            width: 100%;
        }
    }
`

export const LoadingLayer = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 3px 3px 20px 3px;
    background: ${themeColor('white')};
    animation: head-loaderLayer-keyframes 2s infinite;
    z-index: 90;

    @keyframes head-loaderLayer-keyframes {
        from {
            opacity: 0.9;
        }
        to {
            opacity: 0.95;
        }
    }
`

export default LoaderBar
